import * as React from 'react';
import { NoData } from 'components';

export default class NotFound extends React.Component<any, any> {
  public render() {
    return (
      <NoData type="404" text="我走丢了" />
    );
  }
}
